import React from 'react';
import Test from './Test';
import Output from '../../../components/Output';
import TableParametrage from '../components/TableParametrage';

const TableParametrageBody = ({ offerType }) => {
  return <Output>

    <TableParametrage
      offerType={offerType}
      tableType="TABLE_PARAMETRAGE"
    />

    <div style={{ margin: '40px 0' }}/>

    <Test offerType={offerType}/>

  </Output>;
};

export default TableParametrageBody;
